import React, { useEffect } from "react";
import {
  GoogleMap,
  Marker,
  InfoWindow,
  InfoBox,
  LoadScript,
} from "@react-google-maps/api";
import places from "./places.json";

const { useState } = React;
const containerStyle = {
  width: "100%",
  height: "400px",
};

const center = { lat: -36.97368063594747, lng: 144.64503929410512 };
const options = { closeBoxURL: '', enableEventPropagation: true };

function Map() {
  const [region, setRegion] = useState("none");
  const [program, setProgram] = useState("none");
  const [toggleState, setToggleState] = useState("none");
  const [filteredMarkers, setFilteredMarkers] = useState([]);

  useEffect(() => {
    if(region != 'none' && program != 'none'){//Only load when both dropdowns selected.
    if (toggleState == "region") {
      setFilteredMarkers(filterResults(region, toggleState));
    }
    if (toggleState == "program") {
      setFilteredMarkers(filterResults(program, toggleState));
    }
  }
  }, [region, program]);

  const removeDuplicates = (myArr, prop) => {
    return myArr.filter((obj, pos, arr) => {
      return arr.map((mapObj) => mapObj[prop]).indexOf(obj[prop]) === pos;
    });
  };

  const filteredProgramsForDropdown = removeDuplicates(places, "programName");
  const filteredRegionsForDropdown = removeDuplicates(places, "region");

  const handleChange = (value, attribute) => {
    setToggleState(attribute);

    if (attribute == "region") {
      setRegion(value);
    }
    if (attribute == "program") {
      setProgram(value);
    }
  };

  const filterResults = () => {
    let filtered = places.filter((item) => {

      if (region != "all" && program != "all") {
        return item.region == region && item.programName == program;
      } 
      if (region == "all" && program != "all") {
       return item.programName == program;
      } 
      if (program == "all" && region != "all") {
        return  item.region == region; 
      }       
      if (program == "all" && region == "all") {
        return  places; 
      }     
    });
    return filtered;
  };

  const [infoWindowID, setInfoWindowID] = useState("");

  let markers;

    markers = filteredMarkers.map((item, index) => {
      const marker = { lat: item.latitude, lng: item.longitude };

      return (
        <Marker
          key={index}
          position={marker}
          onClick={() => {
            setInfoWindowID(index);
          }}
        >
          {infoWindowID === index && (
            <InfoWindow>
              <div id="content">
                <h1 id="firstHeading" className="firstHeading">
                  {item.title}
                </h1>
                <div id="bodyContent">
                  <p>
                    <strong>Agent: </strong>
                    {item.agent}
                  </p>
                  <p>
                    <strong>Funding Program: </strong>
                    {item.programName}
                  </p>
                  <p>
                    <strong>LGA: </strong>
                    {item.lga}
                  </p>
                  <p>
                    <strong>Region: </strong>
                    {item.region}
                  </p>
                  <p>
                    <strong>URL: </strong>
                    <a href={item.url}>Visit webpage > </a>
                  </p>
                </div>
              </div>
            </InfoWindow>
          )}
        </Marker>
        
      )
    });
 
  return (
    <div id="ag-strategy-map">
      <div id="filter-selects" className="form-group">
        <select
          className="form-control"
          defaultValue={"none"}
          id="programs"
          onChange={(event) => handleChange(event.target.value, "program")}
        >
          <option value="none" disabled>
            Select funding program
          </option>
          <option value="all">All</option>
          {filteredProgramsForDropdown.map((item, index) => (
            <option key={index} value={item.programName}>
              {item.programName}
            </option>
          ))}
        </select>
        <select
          id="region"
          defaultValue={"none"}
          className="form-control"
          onChange={(event) => handleChange(event.target.value, "region")}
        >
          <option value="none" disabled>
            Select region
          </option>
          <option value="all">All</option>
          {filteredRegionsForDropdown.map((item, index) => (
            <option key={index} value={item.region}>
              {item.region}
            </option>
          ))}
        </select>
      </div>

      <LoadScript googleMapsApiKey="AIzaSyDRQxVx3hHxmEBWLLn4PEsYkMyagvNX0-M">

        <GoogleMap
          mapContainerStyle={containerStyle}
          center={center}
          zoom={6}
          id="map-object"
        >
        {markers}


{(filteredMarkers.length == 0 && region != 'none' && program != 'none') &&
<InfoBox

options={options}
position={{lat: -36.9848 , lng: 143.3906}}
>
<div style={{ backgroundColor: 'white', opacity: 1, padding: 12, textAlign: 'center', }}>
  <div style={{ fontSize: 32, fontColor: `#08233B` , width: '200px' , height: '200px;' }}>
    No results!
  </div>
</div>
</InfoBox>
}

        </GoogleMap>
      </LoadScript>
    </div>
  );
}

export default React.memo(Map);
